jQuery(document).ready(function($) {
// On load
//containedLeft();
//containedRight();
//smoothWheelInit();
/* OffCanvas menu */
    $('#menu-toggle').mhOffCanvas();


// Throttled resize function
$(window).on('resize', function() {
  // Do responsive stuff
  //sliderHeight();
//  console.log('breakpoint:');
});

});
